import request from '@/utils/request'


export function login(account, pwd) {
  return request({
    url: '/admin/login',
    method: 'post',
    params: {
      account,
      pwd
    }
  })
}


export function logout() {
  return request({
    url: '/admin/logOut',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js